import React, { useContext } from 'react';
import '../App.css';
import CSS from 'csstype';
import { useAppSelector } from '../app/hooks';

// functions

// images
import crossWhiteIcon from '../icons/cross-white.256.png';
import crossBlackIcon from '../icons/cross-black.256.png';
import debugWhiteIcon from '../icons/debug-white.512.png';
import debugBlackIcon from '../icons/debug-black.512.png';
import errorWhiteIcon from '../icons/error-white.256.png';
import errorBlackIcon from '../icons/error-black.256.png';
import infoWhiteIcon from '../icons/info-white.512.png';
import infoBlackIcon from '../icons/info-black.512.png';
import moveFileWhiteIcon from '../icons/move-file-white.256.png';
import moveFileBlackIcon from '../icons/move-file-black.256.png';
import questionMarkWhiteIcon from '../icons/question-mark-light.256.png';
import questionMarkBlackIcon from '../icons/question-mark-dark.256.png';
import tickWhiteIcon from '../icons/tick-white.512.png';
import tickBlackIcon from '../icons/tick-black.512.png';

// classes

//	--------------------------------------------------------------------------
//
//	P R O P E R T I E S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	H T M L   C U S T O M   C O M P O N E N T S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	C L A S S   D E F I N I T I O N
//
//	--------------------------------------------------------------------------

//	------------------------------------------------------------
//
//	Parameters:
//
//	status: the text to display.
//
//	------------------------------------------------------------

export default function StatusIndicator(props: { status: string }) {
  //
  //	--------------------------------------------------------------------------
  //
  //	R E D U X   S T A T E   H A N D L I N G
  //
  //	--------------------------------------------------------------------------

  const sG_DarkMode: boolean = useAppSelector((state) => state.global.darkMode);

  //	--------------------------------------------------------------------------
  //
  //	F U N C T I O N S
  //
  //	--------------------------------------------------------------------------

  //	-------------------------------------------------
  //
  //	set the colour of the job status
  //
  //	-------------------------------------------------

  function itemColour(args: { status: string; darkMode?: boolean }) {
    //
    var colour: string = 'TRANSPARENT';

    if (args.status.toUpperCase() === 'STAGING') colour = 'BLUE';
    if (args.status.toUpperCase() === 'RETRYING') colour = 'ORANGE';
    if (args.status.toUpperCase() === 'COMPLETED') colour = 'GREEN';
    if (args.status.toUpperCase() === 'REVOKED') colour = 'RED';
    if (args.status.toUpperCase() === 'FAILED') colour = 'RED';
    if (args.status.toUpperCase() === 'ERROR') colour = 'RED';
    if (args.status.toUpperCase() === 'RUNNING') colour = 'GREEN';
    if (args.status.toUpperCase() === 'STOPPED') colour = 'RED';
    if (args.status.toUpperCase() === 'UNKNOWN') colour = 'TRANSPARENT';
    if (args.status.toUpperCase() === 'CRITICAL') colour = 'RED';
    if (args.status.toUpperCase() === 'WARNING') colour = 'ORANGE';
    if (args.status.toUpperCase() === 'INFO') colour = 'BLUE';
    if (args.status.toUpperCase() === 'DEBUG') colour = 'GREEN';
    if (args.status.toUpperCase() === 'NOTSET') colour = 'TRANSPARENT';

    // return something.
    return colour;
    //
  } // itemColour

  //	-------------------------------------------------
  //
  //	set the icon of the job status
  //
  //	-------------------------------------------------

  function itemIcon(args: {
    status: string;
    forceDarkMode: boolean;
    forceLightMode: boolean;
  }) {
    //
    const tickIcon: any =
      sG_DarkMode || args.forceDarkMode ? tickWhiteIcon : tickBlackIcon;
    const infoIcon: any =
      sG_DarkMode || args.forceDarkMode ? infoWhiteIcon : infoBlackIcon;
    const debugIcon: any =
      sG_DarkMode || args.forceDarkMode ? debugWhiteIcon : debugBlackIcon;
    const errorIcon: any =
      sG_DarkMode || args.forceDarkMode ? errorWhiteIcon : errorBlackIcon;
    const crossIcon: any =
      sG_DarkMode || args.forceDarkMode ? crossWhiteIcon : crossBlackIcon;
    const moveFileIcon: any =
      sG_DarkMode || args.forceDarkMode ? moveFileWhiteIcon : moveFileBlackIcon;
    const questionMarkIcon: any =
      sG_DarkMode || args.forceDarkMode ? questionMarkWhiteIcon : questionMarkBlackIcon;
    var icon: any = questionMarkIcon;

    if (args.status.toUpperCase() === 'STAGING') icon = moveFileIcon;
    if (args.status.toUpperCase() === 'RETRYING') icon = moveFileIcon;
    if (args.status.toUpperCase() === 'COMPLETED') icon = tickIcon;
    if (args.status.toUpperCase() === 'REVOKED') icon = crossIcon;
    if (args.status.toUpperCase() === 'FAILED') icon = errorIcon;
    if (args.status.toUpperCase() === 'ERROR') icon = errorIcon;
    if (args.status.toUpperCase() === 'RUNNING') icon = tickIcon;
    if (args.status.toUpperCase() === 'STOPPED') icon = errorIcon;
    if (args.status.toUpperCase() === 'UNKNOWN') icon = questionMarkIcon;
    if (args.status.toUpperCase() === 'CRITICAL') icon = errorIcon;
    if (args.status.toUpperCase() === 'WARNING') icon = errorIcon;
    if (args.status.toUpperCase() === 'INFO') icon = infoIcon;
    if (args.status.toUpperCase() === 'DEBUG') icon = debugIcon;
    if (args.status.toUpperCase() === 'NOTSET') icon = questionMarkIcon;

    // return something.
    return icon;
    //
  } // itemIcon

  //	--------------------------------------------------------------------------
  //
  //	C O M P O N E N T   C O D E
  //
  //	--------------------------------------------------------------------------

  const ITEM_COLOUR: string = itemColour({ status: props.status });
  const FORCE_DARK_MODE: boolean =
    props.status.toUpperCase() !== 'UNKNOWN' && ITEM_COLOUR !== 'GREEN';
  const FORCE_LIGHT_MODE: boolean = false;

  return (
    <div
      className="status-indicator"
      data-colour={ITEM_COLOUR}
      style={{
        flex: '0 0 140px',
        textAlign: 'center',
        width: '140px',
        height: '26px',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
      }}
    >
      <div style={{ flex: '0 0 10px' }} />
      <div style={{ flex: '0 0 20px', display: 'flex' }}>
        <img
          src={itemIcon({
            status: props.status,
            forceDarkMode: FORCE_DARK_MODE,
            forceLightMode: FORCE_LIGHT_MODE,
          })}
          alt={props.status}
          width="20"
          height="20"
        />
      </div>
      <div
        className="text-colour"
        data-white={FORCE_DARK_MODE ? 'T' : 'F'}
        data-black={FORCE_LIGHT_MODE ? 'T' : 'F'}
        style={{
          flex: '1 1',
          fontWeight: '400',
        }}
      >
        {props.status}
      </div>
      <div style={{ flex: '0 0 10px' }} />
    </div>
  );
  //
} // StatusIndicator
